//========================================================================
const cartForm = document.getElementById('cart');
const targetProducts = document.querySelectorAll('.js-option-product');
const checkoutBtn = document.querySelector('.checkout-btn');
const cartItems = JSON.parse(document.querySelector('.js-cart-items').innerText);
const giftCard = document.querySelector('.js-gift-card');
const wrappingRadioButtons = document.querySelectorAll('.js-wrapping-radio');
const giftCardRadioButtons = document.querySelectorAll('.js-gift-card-radio');
const shippingDateSelector = document.getElementById('shipping_date');
const shippingHourSelector = document.getElementById('shipping_hour');
const usePointInput = document.getElementById('use-point');
const remarksInput = document.getElementById('remarks');
const shopIncludesTaxInput = document.getElementById('shop-includes-tax');
const customerIdInput = document.getElementById('customer-id');
const discountCodeInput = document.getElementById('quantity-discount');
const pointChoices = document.querySelectorAll('.js-choice-radio');
const pointUnuse = document.getElementById('point-unable');
const cartItemsTags = JSON.parse(document.querySelector('[data-cart-item-tags]').innerText);
const SPECIAL_PRODUCTS = ['BRIDAL', 'FOOD', 'SAMPLERING', 'RESERVATION'];
const SPECIAL_PRODUCTS_on = ['WRAPPING'];
const globalDeliveryDateInput = document.getElementById('global-delivery-date');
const enableBorderDateInput = document.getElementById('enable-border-date');
const dateClearBtn = document.querySelector('.js-clear');
//========================================================================
// 最短配送日を取得
const getMinDate = () => {
  //最短指定可能日表示するための要素を取得
  const minShippingDate = document.getElementById('min_shipping_date');
  let mindate = '';
  const today = new Date();
  const enableBorderDate = new Date(enableBorderDateInput?.value ?? '');
  // 原則、本日から8日後を最短配送日とする
  const enableDeliberyDate = new Date();
  enableDeliberyDate.setDate(enableDeliberyDate.getDate() + 8);
  const year = enableDeliberyDate.getFullYear();
  const month = ('0' + (enableDeliberyDate.getMonth() + 1)).slice(-2);
  const date = ('0' + enableDeliberyDate.getDate()).slice(-2);
  mindate = `${year}-${month}-${date}`;
  const WeekChars = ['日', '月', '火', '水', '木', '金', '土'];
  const wMindate = new Date(mindate);
  //最短指定可能日を表示
  if (minShippingDate) {
    minShippingDate.innerText =
      '最短ご指定可能日：' + `${month}月${date}日(${WeekChars[wMindate.getDay()]})`;
  }
  // もし今日の日付がenableBorderDateより小さければ、globalDeliveryDateを最短配送日とする
  if (globalDeliveryDateInput && enableBorderDateInput && enableBorderDate > today) {
    const globalDeliveryDate = new Date(globalDeliveryDateInput.value);
    const year = globalDeliveryDate.getFullYear();
    const month = ('0' + (globalDeliveryDate.getMonth() + 1)).slice(-2);
    const date = ('0' + globalDeliveryDate.getDate()).slice(-2);
    mindate = `${year}-${month}-${date}`;
    const wMindate = new Date(mindate);
    if (minShippingDate) {
      minShippingDate.innerText =
        '最短ご指定可能日：' + `${month}月${date}日(${WeekChars[wMindate.getDay()]})`;
    }
  }
  return mindate;
};

//最長配送日を取得
const getMaxDate = () => {
  const today = new Date();
  const maxdate = new Date(today.getTime() + 38 * 24 * 60 * 60 * 1000);
  const year = maxdate.getFullYear();
  const month = ('0' + (maxdate.getMonth() + 1)).slice(-2);
  const date = ('0' + maxdate.getDate()).slice(-2);
  const formattedMaxdate = `${year}-${month}-${date}`;
  return formattedMaxdate;
};

//========================================================================
const config = {
  locale: 'ja',
  dateFormat: 'Y-m-d',
  minDate: getMinDate(),
  maxDate: getMaxDate(),
  disableMobile: true,
  onChange: function (selectedDates, dateStr, instance) {
    if (selectedDates.length > 0) {
      const today = new Date();
      const selectedDate = new Date(selectedDates[0]);
      if (today.getDate() === selectedDate.getDate()) {
        instance.set('minDate', getMinDate());
      } else {
        instance.set('minDate', getMinDate());
      }
      sessionStorage.setItem('shipping_date', dateStr);
    }
  },
  defaultDate: sessionStorage.getItem('shipping_date') || '',
};

// flatpicker init
const fp = flatpickr('#shipping_date', config);
// カレンダーを翻訳から除外する識別子を追加
if (fp.calendarContainer) {
  fp.calendarContainer.dataset['sttIgnore'] = true;
}

// 日付をリセット
if (dateClearBtn) {
  dateClearBtn.addEventListener('click', () => {
    fp.clear();
    sessionStorage.removeItem('shipping_date');
  });
}

// SPECIAL_PRODUCTSのタグ飲みを抽出し、重複を削除する
console.log(cartItemsTags);
const specialTagsInCart = cartItemsTags.filter((tag) => SPECIAL_PRODUCTS.includes(tag));
const specialTagsAreEqual = specialTagsInCart.every((tag) => tag === specialTagsInCart[0]);
const specialTagsInCartUnique = [...new Set(specialTagsInCart)];

const specialTagsInCart_on = cartItemsTags.filter((tag) => SPECIAL_PRODUCTS_on.includes(tag));
const specialTagsAreEqual_on = specialTagsInCart_on.every((tag) => tag === specialTagsInCart[0]);

const checkToProceedToCheckout = () => {
  if (cartItems.length === 1) {
    return true;
  } else {
    // 1つも特殊タグが含まれていなければチェックアウト可能
    if (specialTagsInCart.length === 0) {
      console.log('1つも特殊タグが含まれていなければチェックアウト可能');
      return true;
    }
    // カートの商品数と特殊タグの数が同じで、かつ特殊タグが全て同じならチェックアウト可能
    if (cartItems.length === specialTagsInCart.length && specialTagsAreEqual) {
      console.log(
        'カートの商品数と特殊タグの数が同じで、かつ特殊タグが全て同じならチェックアウト可能'
      );
      return true;
    }
    // タグ「WRAPPING」が含まれている場合はtrueを返す
    if (cartItemsTags.includes('wrapping')) {
      console.log('タグ「WRAPPING」が含まれているのでチェックアウト可能');
      return true;
    }
    // 2つ以上特殊タグが含まれていればチェックアウト不可
    if (specialTagsInCartUnique.length > 1 && !specialTagsAreEqual) {
      console.log('2つ以上特殊タグが含まれていればチェックアウト不可');
      return false;
    }
  }
  return false;
};

window.addEventListener('DOMContentLoaded', () => {
  const lastSelectedValues = {};
  wrappingRadioButtons.forEach((radio) => {
    radio.addEventListener('change', (e) => {
      if (!lastSelectedValues[e.target.name]) {
        lastSelectedValues[e.target.name] = 0;
      }

      const totalPriceEl = document.querySelector('#cart-total');
      const optionPrice = Number(e.target.dataset.optionPrice) / 100;
      // 選択したグループに保存された最後に選んだ値を取得
      const savedPrice = lastSelectedValues[e.target.name];

      // 現在のカートの合計金額を取得
      const currentTotal = Number(totalPriceEl.dataset.currentTotal) / 100;

      // 現在の金額から、最後に選んだ値を引き、選択したオプションの金額を足す
      const updatedTotal = currentTotal - savedPrice + optionPrice;

      // 合計金額の表示を更新
      totalPriceEl.innerText = `¥${updatedTotal.toLocaleString()}`;

      //グループごとに選択されたオプションの金額を保存
      lastSelectedValues[e.target.name] = optionPrice;

      // カートの合計金額を更新
      totalPriceEl.dataset.currentTotal = updatedTotal * 100;
    });
  });
  // 数値以外は入力不可
  if (usePointInput) {
    usePointInput.addEventListener('input', (event) => {
      event.target.value = event.target.value.replace(/[^0-9]+/i, '');
    });
  }
  // 本日から8日後を最短配送日とする
  if (shippingHourSelector) {
    shippingHourSelector.value = sessionStorage.getItem('shipping_hour') || '';
    // セッションストレージにデータが入っていればオプションを選択状態にする
    if (sessionStorage.getItem('shipping_hour')) {
      const options = shippingHourSelector.querySelectorAll('option');
      options.forEach((option) => {
        if (option.value === sessionStorage.getItem('shipping_hour')) {
          option.selected = true;
        }
      });
    }
    // オプションを選択した時にセッションストレージにデータを保存する
    shippingHourSelector.addEventListener('change', (event) => {
      sessionStorage.setItem('shipping_hour', event.target.value);
    });
  }
  // 備考を入力した時にセッションストレージにデータを保存
  if (remarksInput) {
    remarksInput.addEventListener('change', (event) => {
      sessionStorage.setItem('remarks', event.target.value);
    });
    // もしセッションストレージにデータが入っていれば備考欄にデータを入れる
    if (sessionStorage.getItem('remarks')) {
      remarksInput.value = sessionStorage.getItem('remarks');
    }
  }
  if (pointChoices.length > 0) {
    pointChoices.forEach((pointChoice) => {
      pointChoice.addEventListener('change', (event) => {
        console.log(event.target.value);
        if (event.target.value === 'enable') {
          usePointInput.removeAttribute('disabled');
          usePointInput.value = 0;
        } else {
          usePointInput.setAttribute('disabled', true);
        }
      });
    });
  }
  //注文者氏名入力インプットを取得
  const attributeNameInput = document.getElementById('attribute-name');
  //セッションストレージのattribute_nameのデータを取得
  let savedAttributeName = sessionStorage.getItem('attribute_name');
  if (savedAttributeName) {
    attributeNameInput.value = savedAttributeName;
  }
  if (attributeNameInput) {
    //注文者氏名を入力した際にセッションストレージにデータを保存
    attributeNameInput.addEventListener('change', (event) => {
      let attributeName = attributeNameInput.value;
      sessionStorage.setItem('attribute_name', attributeName);
      savedAttributeName = attributeName;
    });
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      if (!checkToProceedToCheckout()) {
        alert(
          '通常商品と食品やサンプルリング、予約商品は同時に購入できません。\nカートを確認し、購入を完了するか商品を削除してください。'
        );
        // エラーが発生した場合、ボタンを再度有効化する
        e.preventDefault();
        return;
      }

      checkoutBtn.disabled = true;
      let shippingDate = '指定なし';
      let shippingHour = '指定なし';
      if (shippingDateSelector) {
        shippingDate = shippingDateSelector.value || '指定なし';
      }
      if (shippingHourSelector) {
        shippingHour = shippingHourSelector.value || '指定なし';
      }
      const remarks = remarksInput.value;

      //attributeNameInputが空もしくは存在しない場合はエラーモーダルを表示
      if (attributeNameInput.value === '' || !attributeNameInput.value) {
        alert('ご注文者氏名をご入力ください。');
        // エラーが発生した場合、ボタンを再度有効化する
        checkoutBtn.disabled = false;
        return;
      }

      // 選択されたラッピング商品があればカートに追加
      if (getOptionsToAdd().length > 0) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: getOptionsToAdd() }),
        }).catch((error) => {
          console.error('error', error);
          checkoutBtn.disabled = false;
        });
      }

      // クーポンコード取得
      const cart = await fetchCart();
      const couponSuccess = await getDiscountCode(
        cart,
        customerIdInput?.value || '',
        shopIncludesTaxInput?.value || '',
        usePointInput?.value || '',
        !pointUnuse ? true : pointUnuse.checked
      );

      // クーポンコードが取得できなかった場合はチェックアウトを中止
      if (!couponSuccess) {
        return;
      }

      // .anygift-form-area DOM がある場合はAnyGift有効化
const agFormArea = document.getElementsByClassName("anygift-form-area");
if (agFormArea.length > 0) {
  const agContainer = document.getElementsByClassName(
    "anygift-cart-page-container"
  )[0];
  const agMessageCardId = agContainer
    .getElementsByClassName("anygift-message-card-area")[0]
    .getElementsByClassName("ag-border-anygift-key-green")[0]
    .getAttribute("data-anygift-message-card-id");
  const agMessage = agContainer.getElementsByClassName(
    "anygift-form-message-input"
  )[0].value;
  const agSenderName = agContainer.getElementsByClassName(
    "anygift-form-from-input"
  )[0].value;

  const properties = {
    ギフト購入: "有効",
    ギフト購入メッセージ: agMessage,
    ギフト贈り主: agSenderName,
    メッセージカード: agMessageCardId,
  };
  for (let i = 0; i < cart.items.length; i++) {
    const _item = cart.items[i];
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: String(_item.variant_id),
          quantity: _item.quantity, // 商品数量を保持
          properties: {
            ..._item.properties,
            ...properties,
          },
        }),
      });
      const data = await response.json();
    } catch (error) {
      checkoutBtn.disabled = false;
      return;
    }
  }
} else {
  // AnyGift ではない場合は、 ギフトの properties を削除する
  const agPropertyKeys = [
    "ギフト購入",
    "ギフト購入メッセージ",
    "ギフト贈り主",
    "メッセージカード",
  ];
  for (let i = 0; i < cart.items.length; i++) {
    const _item = cart.items[i];

    let newProperties = _item.properties;
    agPropertyKeys.forEach((key) => delete newProperties[key]);

    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: String(_item.variant_id),
          quantity: _item.quantity, // 商品数量を保持
          properties: newProperties,
        }),
      });
      const data = await response.json();
    } catch (error) {
      checkoutBtn.disabled = false;
      return;
    }
  }
}

      // URLパラメータを初期化
      let paramString = '';

      // 配送日が指定されていればURLパラメータに追加
      if (shippingDate) {
        paramString += `${paramString ? '&' : ''}attributes[shipping_date]=${shippingDate}`;
      }
      // 配送時間が指定されていればURLパラメータに追加
      if (shippingHour) {
        paramString += `${paramString ? '&' : ''}attributes[shipping_hour]=${shippingHour}`;
      }
      if (savedAttributeName) {
        paramString += `${
          paramString ? '&' : ''
        }attributes[注文者氏名]=${savedAttributeName.replace(/[\s\u3000]+/g, '')}`;
      }

      // 備考が入力されていればURLパラメータに追加
      if (remarks) {
        paramString += `${paramString ? '&' : ''}note=${remarks}`;
      }
      console.log('paramString', paramString);

      if (discountCodeInput && discountCodeInput.value) {
        const couponApplied = await couponCodeApply(discountCodeInput.value);
        console.log('couponApplied', couponApplied);
        if (!couponApplied) {
          return;
        }
        paramString += `${paramString ? '&' : ''}`;
      }
      console.log('paramString', paramString);
      window.location.href = `/checkout?${paramString}`;
    });
  }

  MicroModal.init({
    awaitCloseAnimation: true,
    awaitOpenAnimation: true,
    disableScroll: true,
  });
});
/**
 * カート情報取得
 * @returns {Promise<Cart>}
 */
const fetchCart = async () => {
  const result = await fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((response) => response.json());
  return result;
};

/**
 * クーポンコード取得
 * @param {cart} cart
 * @param {string} customerId
 * @param {boolean} shopIncludeTax
 * @param {string} usePoint
 * @param {boolean} unUse
 * @returns {Promise<boolean>}
 */
const getDiscountCode = async (cart, customerId, shopIncludeTax, usePoint, unUse) => {
  console.log('unUse', unUse);
  // 会員IDがなければクーポンコード取得をスキップ
  if (!customerId) {
    return true;
  }
  // 使用しないにチェックが入っていればクーポンコード取得をスキップ
  if (unUse) {
    return true;
  }
  const hostUrl = '/apps/crosspoint/get-coupon';
  // パラメータをFormDataにセット
  const form_data = new FormData();
  form_data.append('cart', JSON.stringify(cart));
  form_data.append('memberId', customerId);
  form_data.append('shopIncludeTax', shopIncludeTax);
  form_data.append('usePoint', usePoint);
  const result = fetch(hostUrl, {
    method: 'POST',
    body: form_data,
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status == 'success') {
        discountCodeInput.value = data.result.discountCode;
        return true;
      }
      if (data.status == 'skip') {
        discountCodeInput.value = '';
        return true;
      }
      if (data.status == 'error') {
        discountCodeInput.value = '';
        // openErrorMessageDialog(data.result);
        alert(data.result);
        checkoutBtn.disabled = false;
        return false;
      }
    });
  return result;
};

/**
 * クーポンコードを適用するためのページにアクセスする関数
 * @param {string} code
 */
const couponCodeApply = async (code) => {
  const result = fetch(`/discount/${code}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      console.log(response.statusText);
      return true;
    })
    .then((data) => {
      console.log(data);
      return true;
    })
    .catch((error) => {
      console.error('error', error);
      return false;
    });
  return result;
};
const getOptionsToAdd = () => {
  const items = [];
  console.log(wrappingRadioButtons);
  console.log(giftCardRadioButtons);
  wrappingRadioButtons.forEach((radio) => {
    if (radio.checked) {
      if (radio.dataset.variantId === 'none') return;
      items.push({
        id: Number(radio.dataset.variantId),
        quantity: 1,
        properties: {
          対象商品SKU: radio.dataset.relationProductSku,
        },
      });
    }
  });
  giftCardRadioButtons.forEach((radio) => {
    if (radio.checked) {
      if (radio.dataset.variantId === 'none') return;
      items.push({
        id: Number(radio.dataset.variantId),
        quantity: 1,
        properties: {
          対象商品SKU: radio.dataset.relationProductSku,
        },
      });
    }
  });
  return items;
};
